/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_7_Paragraphs_1Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_7_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_7_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move on to filters and PivotTables when the number of records makes manual inspection awkward. Before summarizing, make sure each column contains a consistent kind of value and the header row is clear. A pivot can help answer which region contributed the most revenue, but it cannot fix a source table in which quantities, labels and notes are mixed in the same column.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_7_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_7_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当记录数量较多，人工检查变得困难时，再学习筛选和数据透视表。汇总前确保每列内容类型一致、表头清晰。透视表可以帮助判断哪个区域贡献了最多收入，但不能自动修复数量、标签和备注混在同一列的源数据问题。`)
};

/**
* | output |
* | --- |
* | "Move on to filters and PivotTables when the number of records makes manual inspection awkward. Before summarizing, make sure each column contains a consisten..." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_7_Paragraphs_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_7_paragraphs_1 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_7_Paragraphs_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_7_Paragraphs_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_7_paragraphs_1(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_7_paragraphs_1(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_7_paragraphs_1 as "gc.search_guides.what_is_gridcraft.sections.7.paragraphs.1" }